import { useLocation } from 'react-router-dom';
import React from 'react';

const ScrollTop = () => {
    const { pathname } = useLocation();

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto',
        });
    }, [pathname]);

    return null;
};

export default ScrollTop;
